var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 18,
    viewBox: "0 0 12 18",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 0C2.67327 0 0 2.75583 0 6.18774C0 9.61856 6 18 6 18C6 18 12 9.61856 12 6.18774C12 2.75583 9.32673 0 6 0ZM6 8.99946C4.47317 8.99946 3.27254 7.76235 3.27254 6.18666C3.27254 4.61205 4.47212 3.37385 6 3.37385C7.52683 3.37385 8.72746 4.61097 8.72746 6.18666C8.72746 7.76232 7.52686 8.99946 6 8.99946Z",
    fill: "#currentColor"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.ce26d4969bca43e5bfb66e1c54f87d97.svg";
export { ForwardRef as ReactComponent };